export const VERSION: string = '1.6.3';
export const VERSIONNAME = 'ShutDown';
export const versionTypeEnum = {
    WEB: 1,
    MOBILE: 2,
};
